import {
  findMostSpecificPatternMatch,
  isParameterSegment,
  splitPath,
} from './endpoint-identity';
import {
  isKnownIsoCountryCodeSegment,
  isKnownIsoLanguageCodeSegment,
  isKnownLocaleCatalogSegment,
} from './locale-segment-catalog';
import { segmentValueClass } from './segment-value-class';

function isLiteralRouteWord(segment: string): boolean {
  return (
    !isParameterSegment(segment) &&
    segmentValueClass(segment) === 'route_word' &&
    !isKnownLocaleCatalogSegment(segment) &&
    !isKnownIsoLanguageCodeSegment(segment) &&
    !isKnownIsoCountryCodeSegment(segment)
  );
}

export function doesUntypedParamSwallowLiteralRouteWord({
  reportPath,
  endpointPath,
}: {
  reportPath: string;
  endpointPath: string;
}): boolean {
  const reportSegments = splitPath(reportPath);
  const endpointSegments = splitPath(endpointPath);

  if (reportSegments.length !== endpointSegments.length) {
    return false;
  }

  const segmentPairs = reportSegments.map((segment, index) => ({
    segment,
    endpointSegment: endpointSegments[index] ?? '',
  }));
  const sharesLiteralSegment = segmentPairs.some(
    ({ segment, endpointSegment }) =>
      !isParameterSegment(segment) &&
      !isParameterSegment(endpointSegment) &&
      segment.toLowerCase() === endpointSegment.toLowerCase(),
  );

  return (
    !sharesLiteralSegment &&
    segmentPairs.some(
      ({ segment, endpointSegment }) =>
        isParameterSegment(endpointSegment) && isLiteralRouteWord(segment),
    )
  );
}

export function findMostSpecificPatternMatchKeepingRouteWords<T>({
  concretePath,
  candidates,
  patternOf,
}: {
  concretePath: string;
  candidates: readonly T[];
  patternOf: (candidate: T) => string;
}): T | undefined {
  return findMostSpecificPatternMatch({
    concretePath,
    candidates: candidates.filter(
      (candidate) =>
        !doesUntypedParamSwallowLiteralRouteWord({
          reportPath: concretePath,
          endpointPath: patternOf(candidate),
        }),
    ),
    patternOf,
  });
}
